import React from 'react';

import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import { namespace, actions, selectors } from './';

import wrapMain from '../../wrap-main';

import RichTextField from '../../../shared/form-elements/rich-text';
import SelectField from '../../../shared/form-elements/select/field';

function Editor({ intl, can, languages, ...props }) {
	const code = props.params.code;

	return (
		<div className='form-container lang-rules-editor'>
			<div className='form-container__head'>
				<h2 className='icon-edit'>
					{intl('create/edit rule')}
				</h2>
			</div>
			<div className='form-container__body'>
				<form onSubmit={props.handleSubmit}>
					<div className='lang-rules-editor-lang'>
						<Field
							name='country'
							placeholder={intl('Country')}
							component={SelectField}
							searchable={true}
							disabled={!!code}
							options={props.locationsLookups}
						/>
					</div>
					{languages.map((lang, index) => (
						<div
							className='lang-rules-editor-rule'
							key={index}
						>
							<Field
								name={`rules_${lang.id}`}
								placeholder={intl(`Rules (${lang.id} translation)`)}
								component={RichTextField}
							/>
						</div>
					))}
					<div className='banners-buttons'>
						{can('edit') && (
							<button className='ui-btn ui-btn-primary'>
								{intl('Save')}
							</button>
						)}
						<Link
							className='ui-btn ui-btn-cancel'
							to='/offer-location-rules/geo-rules'
						>
							{intl('Cancel')}
						</Link>
					</div>
				</form>
			</div>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		initialValues: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		// -----------------------------------------
		languages: selectors.getLanguages(state),
		can: selectors.getCan(state)
	};
}

function validate(values) {
	const errors = {};
	const notEmptyFields = ['rules_en', 'rules_ru'];

	notEmptyFields.forEach((field) => !values[field] && (errors[field] = 'Should not be empty'));

	return errors;
}

const Main = reduxForm({ form: `${namespace}Form`, validate, enableReinitialize: true })(Editor);

export default connect(mapStateToProps, actions.own)(wrapMain(Main));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/offer-location-rules/geo-rules/edit/main.js